//events, actions
var EVENTS = require('./shared/events.js');
var MODALS = require('./shared/modals.js');

//libs
window.$ = require('jquery');

//components
require('./components/modals.js')(EVENTS);
require('./components/downloadImage.js')(EVENTS, MODALS);
require('./components/agreementService.js')(EVENTS, MODALS);
require('./components/facebookSharing.js')(EVENTS);
require('./components/tracking.js')(EVENTS, MODALS);

//main
require('./routing.js')(EVENTS, MODALS);
